import { Button, Col, Modal, notification, Row, Typography } from 'antd';
import React, { useState } from 'react';
import { useAddProductsToMpCatalogue } from '../../../../utils/api/mpCatalogue/useAddProductsToMpCatalogue';
import { useAssociatedProducts } from '../../../../utils/zustand';
import MarketplaceCategoryColumn from './MarketplaceCategoryColumn';
import SelectedProductsColumn from './SelectedProductsColumn';

const { Title } = Typography;

const ProductsAssociation = () => {
  // État pour la catégorie sélectionnée (partagé entre composants)
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAssociated, setIsAssociated] = useState(false);
  const { associatedProducts, removeAssociatedProduct } =
    useAssociatedProducts();
  const { addProductsToCatalogue, isLoading } = useAddProductsToMpCatalogue();

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleAssociateProducts = async () => {
    const body = {
      products: associatedProducts.map((product) => product.reference),
    };
    const categoryId = selectedCategory.id;

    try {
      await addProductsToCatalogue({ categoryId, body });
      setIsAssociated(true);
      notification.success({
        message: 'Association réussie',
        description:
          'Les produits ont été associés avec succès à la catégorie marketplace.',
        placement: 'bottomRight',
        duration: 3,
      });
      setIsModalOpen(false);
    } catch (error) {
      console.log('error', error);
      const errors = error?.response?.data?.errors;
      const errorDescription = errors?.length ? (
        <ul style={{ margin: 0, paddingLeft: 16 }}>
          {errors.map((err, index) => (
            <li key={index}>{err}</li>
          ))}
        </ul>
      ) : (
        error?.response?.data?.message ||
        error?.response?.data?.detail ||
        error?.message ||
        "Une erreur est survenue lors de l'association des produits."
      );
      notification.error({
        message: "Erreur d'association",
        description: errorDescription,
        placement: 'bottomRight',
        duration: 3,
      });
    }
  };

  return (
    <div>
      <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>
        <Col>
          <Title level={5} style={{ margin: 0 }}>
            Associer les produits sélectionnés aux catégories MP
          </Title>
        </Col>
        <Col>
          <Button
            type="primary"
            onClick={handleOpenModal}
            disabled={
              !selectedCategory ||
              associatedProducts.length === 0 ||
              isAssociated
            }
          >
            Ajouter à la catégorie marketplace
          </Button>
        </Col>
      </Row>

      <Row gutter={16}>
        <SelectedProductsColumn
          associatedProducts={associatedProducts}
          removeAssociatedProduct={removeAssociatedProduct}
        />
        <MarketplaceCategoryColumn
          selectedCategory={selectedCategory}
          onCategorySelect={setSelectedCategory}
        />
      </Row>

      <Modal
        title="Confirmer l'association"
        open={isModalOpen}
        onOk={handleAssociateProducts}
        onCancel={handleCancel}
        confirmLoading={isLoading}
        okText="Confirmer"
        cancelText="Annuler"
      >
        <p>
          Voulez-vous vraiment associer{' '}
          <strong>{associatedProducts.length}</strong>{' '}
          {associatedProducts.length > 1 ? 'produits' : 'produit'} à la
          catégorie marketplace suivante ?
          <ul
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'start',
            }}
          >
            <li style={{ display: 'flex', gap: 4 }}>
              <strong>Nom :</strong> {selectedCategory?.label}
            </li>
            <li style={{ display: 'flex', gap: 8 }}>
              <strong>Code :</strong> {selectedCategory?.name}
            </li>
          </ul>
        </p>
      </Modal>
    </div>
  );
};

export default ProductsAssociation;
